import { Auth0Provider, useAuth0 } from '@auth0/auth0-react'
import { useEffect, type ReactNode } from 'react'
import { registerTokenGetter } from './api'

export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      }}
    >
      <TokenBridge>{children}</TokenBridge>
    </Auth0Provider>
  )
}

function TokenBridge({ children }: { children: ReactNode }) {
  const { getAccessTokenSilently } = useAuth0()
  useEffect(() => {
    // No isAuthenticated check here: that snapshot goes stale in the closure
    // and made the first request volley after login go out tokenless.
    // getAccessTokenSilently itself settles auth state (or throws → undefined).
    registerTokenGetter(async () => {
      try {
        return await getAccessTokenSilently()
      } catch {
        return undefined
      }
    })
  }, [getAccessTokenSilently])
  return <>{children}</>
}

export function useIsAdmin(): boolean {
  const { user } = useAuth0()
  return Boolean((user as Record<string, unknown> | undefined)?.['https://app.etainabl.com/isAdmin'])
}
